import * as React from "react";
import styled from "styled-components";
import { createPortal } from "react-dom";
import { PoseGroup } from "react-pose";
import shortId from "shortid";

import Item from "./Item";

const Base = styled.div`
  position: fixed;
  top: 16px;
  left: 16px;
  right: 16px;
  bottom: 16px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 3000;
`;

type NotifyPayload = {
  title: React.ReactNode;
  description?: React.ReactNode;
  type: "success" | "error" | "warning";
  timeout?: number;
};

type NotifyContextType = {
  notify: (payload: NotifyPayload) => void;
};

export const NotifyContext = React.createContext({} as NotifyContextType);

type Props = {
  children: any;
};

function NotifyManager({ children }: Props) {
  const elementRef = React.useRef<HTMLDivElement | null>(null);

  const [items, setItems] = React.useState<
    Array<NotifyPayload & { id: string }>
  >([]);

  if (!elementRef.current) {
    const element = document.createElement("div");
    element.id = "notify-root";
    // element.style.position = "fixed";
    // element.style.top = "16px";
    // element.style.bottom = "16px";
    // element.style.left = "16px";
    // element.style.pointerEvents = "none";
    // element.style.right = "16px";
    // element.style.display = "flex";
    // element.style.
    document.body.appendChild(element);
    elementRef.current = element;
  }

  const contextPayload = React.useMemo(
    () => ({
      notify: (payload: NotifyPayload) => {
        const id = shortId();

        setItems(items => [...items, { ...payload, id }]);

        setTimeout(() => {
          setItems(items => items.filter(x => x.id !== id));
        }, payload.timeout || 2000);
      }
    }),
    []
  );

  return (
    <>
      <NotifyContext.Provider value={contextPayload}>
        {children}
      </NotifyContext.Provider>
      {createPortal(
        <Base>
          <PoseGroup>
            {items.map(item => (
              <Item
                key={item.id}
                title={item.title}
                description={item.description}
                type={item.type}
              />
            ))}
          </PoseGroup>
        </Base>,
        elementRef.current
      )}
    </>
  );
}

export default NotifyManager;
